module.exports = __webpack_public_path__ + "static/img/f_1.3bcbdc6e.png";